import { render, staticRenderFns, recyclableRender, components } from "./tki-qrcode.vue?vue&type=template&id=143ec824&xlang=wxml&minapp=mpvue&"
var renderjs
import script from "./tki-qrcode.vue?vue&type=script&lang=js&"
export * from "./tki-qrcode.vue?vue&type=script&lang=js&"
import style0 from "./tki-qrcode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/tki-qrcode/tki-qrcode.vue"
export default component.exports